import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHelp = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		clipRule: "evenodd",
		d: "M15.833 17.5H4.167c-.921 0-1.667-.746-1.667-1.667V4.167c0-.921.746-1.667 1.667-1.667h11.666c.921 0 1.667.746 1.667 1.667v11.666c0 .921-.746 1.667-1.667 1.667Z",
		stroke: "#748094",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.999 11.041v-.208c0-.68.42-1.05.842-1.333.412-.278.824-.64.824-1.306a1.666 1.666 0 1 0-3.333 0M9.998 13.333a.208.208 0 1 0 .002.417.208.208 0 0 0-.002-.417",
		stroke: "#748094",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgHelp;
